import { color } from "@funded-here-interface/common";
import { Anchor, Checkbox, Group, MantineProvider } from "@mantine/core";
import { FC } from "react";
import { useStyle } from "./SignupCheckbox.styles";
import useGetFhDocument from "../../hooks/useFhDocument";
import { downloadFile } from "@funded-here-interface/common/src/Utils/file";
import { ToastContainer, toast } from "react-toastify";
import { FileType } from "@funded-here-interface/common/src/constant/enum";

interface IProps {
  onChange: (checked: boolean) => void;
}

const SignupCheckbox: FC<IProps> = ({ onChange }) => {
  const { classes } = useStyle();
  const useGetFhDocumentMutation = useGetFhDocument();
  const enum File {
    PLATFORM_AGREEMENT = "Platform Agreement v1.0.pdf",
  }
  const fileNameToDownloadName = {
    [File.PLATFORM_AGREEMENT]: "Platform Agreement v1.0",
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.currentTarget.checked);
  };

  const handleDownload = (fileName: File) => {
    useGetFhDocumentMutation.mutate(
      { fileName },
      {
        onSuccess: (data: Blob) => {
          downloadFile(data, fileNameToDownloadName[fileName], FileType.PDF);
        },
        onError: (e) => {
          toast.error((e as Error).message);
        },
      }
    );
  };

  return (
    <Group position="left" spacing="xs" noWrap>
      <MantineProvider theme={{ cursorType: "pointer" }}>
        <Checkbox onChange={handleChange} />
      </MantineProvider>
      <ToastContainer />
      <div style={{ fontSize: "14px" }}>
        I have read, understood and agree to be bound by the{" "}
        <Anchor
          color={color.FHGREEN}
          underline={false}
          onClick={() => handleDownload(File.PLATFORM_AGREEMENT)}
          className={classes.agreement}
        >
          Platform Agreement.
        </Anchor>
      </div>
    </Group>
  );
};

export default SignupCheckbox;
